
import {Component, Vue} from 'vue-facing-decorator';
import {Html5QrcodeScanner, Html5QrcodeScanType, Html5QrcodeSupportedFormats} from "html5-qrcode";
import {DBScans, DBTicket, DBTickets, EventUsers, ScanMode, ScanResult} from "@/@types";
import {deleteALLScans, scan} from "@/api";
import {get, onValue, set} from "firebase/database";
import {getCurrentUser, getRef} from "@/rtdb";
import {User} from 'firebase/auth';
import {tr} from "vuetify/locale";

let beepInfo: HTMLAudioElement | null = null//new Audio('data:audio/ogg;base64,UklGRgIJAABXQVZFZm10IBAAAAABAAEARKwAAESsAAABAAgAZGF0YTIFAAB/cHd2fIKEkpiQm5Gcg41ngmVtX2hkcWdyeICBg4WFlICQhZWMloiYj5GGioGIe3V1bm9laGR1a3d1gH2FeoeFioeKio2Lg4iEiISHg46Fh4CEfoF3eXh2c29ucXNvdXZ9fIB9h4WKiY6OkouKiYeFg4ODhX9/e314eHN4d3d1dnV4dnZ6fH9/gYKIhoiIjIyNiYuJh4OCgYKAfHx6eXV0c3d1d3d6ent5fH6AgoOFh4mHiIiJiIiHiYaEgYB/fnt6enl3dnV1d3d5enx9fn2AgYODhYeJiIeHh4aFhYWFg4F/fnx7eXl5eXh3d3h4eHp8fn+AgYODhIWGh4iHh4aFhIKCgoKAf359e3l4eXl5eXp6e3p7fX+AgYKDhISEhYaGhoWFhYOCgYCAf359fXx6eXl5eXp6fHx9fX6AgYKDhIWFhISEhISEhISDgYB/fn59fHx8e3p6enp7fH1+f3+AgYGCgoOEhISEg4OCgoGCgYGAf39+fXx8fHx8fHx8fHx9fn+AgIGBgYKCg4ODg4ODgoGBgICAf39/fn19fHx8fHx9fX1+fn9/gIGBgoKCgoKCgoKCgoKBgIB/f39+fn5+fX19fX19fX5+f3+AgIGBgoKCgoGBgYCAgICAgICAf39/f35+fn5+fn5+fn5/f39/gICAgIGBgYKCgYGBgICAf39/fn5+fn5+fn5/f39/gICAgIGBgYGBgICAf39/f39/f39/f39/f4CAgWZdc4yMiamdnZCwi4ZsaD49REdIWHl9n7PPvcq/u5+chW1bVU8+RkRRUW5ygoScoa20tq+lqJuWg35kYFRVSk1NVFxqe4KUn7Gzvre2qaWWh3NhUkZEQUREU111hZymtb3ExL60opN/cFpMPTs4QUlWZHiOobO8xMLCurCci3RjU0g/OjxDUV9ygZWktb3DwLqwpJWDcF1QRkNBRUtXZnmKmqexuby7s6majHxtXlJJRkhOVmBufI2cqK+0s7KropSGd2pfVlBNTlNdaHSAjZmkrK+uqqSckYR3amBZVVNUWGBrd4OOmKGnq6umn5aMgndsYltXV1pfZW55hZCZn6OlpaKbk4h+dWxlX1tbXmRrc3yFj5edoKGfnJaPh310bGZjYGBiZ252foaOlJqdnpyYk4yFfXVtaGRjZGdrcXiAiI6Tl5mamZWPiIJ7dW9qZ2Zoa291e4GIjpKVlpaUkYyGgHp1cG1ramtuc3h9goeMkJKTkpCNiYWAenZycG9vcHJ1eX6ChoqMjo+PjYqHg397eHVzcnJzdXd7foKFiIqLjIuKiIWCfnt4dnV0dHV3en2AgoWHiYqJiIeFg4B+e3l4d3d3eHp8foGDhIaHh4eGhYOBf358enl5eXp7fH1/gIKDhIWFhYSEgoF/fn18e3p6e3x9fn+AgoODhISDg4KBgH9+fXx8fHx8fX1+f4CBgoKDg4OCgYGAf35+fX19fX19fn+AgIGBgoKCgoKBgIB/fn5+fX19fn5+f4CAgYGBgYGBgYGAgH9/fn5+fn5+fn9/gICAgYGBgYGBgICAf39+fn5+fn5/f3+AgICBgYGBgYCAgH9/f39+fn5+f39/f4CAgICAgICAgICAf39/f39/f39/f39/gICAgICAgICAgIB/f39/f39/f39/f3+AgICAgICAgICAgH9/f39/f39/f39/gICAgICAgICAgICAf39/f39/f39/f3+AgICAgICAgICAgIB/f39/f39/f39/f4CAgICAgICAgICAf39/f39/f39/f39/YmV4dFoDAAAAFwAAHwa1Cv//////////HARJBQYItQawz6VW/38AAKDOpVb/fwAAAAAAAAAAAAAAAKVW/38AAAAAAAAAAAAAsM+lVv9/AAD0DLoMAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAKIQ8lDhIQJA0AAAAAAAAAAKKrqjIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD+Kn1uvkX9gAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAATG9naWMgUHJvIFgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADIwMTUtMDItMDEwMzo0NDowMUB8dgkAAAAAAQAAAAAAgiNKQxBUAPdw2KVW/38AAAAd4wAAYAAAAAAAAAAAAADG9BUKAQAAAHBQbXX/fwAAoNClVv9/AADqxi6LAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABjdWUgHAAAAAEAAAAAAAAAAAAAAGRhdGEAAAAAAAAAAAAAAABMSVNUHgAAAGFkdGxsYWJsEgAAAAAAAABUZW1wbzogMTIwLjAAAA==')
let beepError: HTMLAudioElement | null = null//new Audio("error.wav")
let beepOk: HTMLAudioElement | null = null//new Audio("data:audio/wav;base64,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");

function unlockAudio() {

  beepInfo = new Audio('data:audio/ogg;base64,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')
  beepError = new Audio("error.wav")
  beepOk = new Audio("data:audio/wav;base64,//uQRAAAAWMSLwUIYAAsYkXgoQwAEaYLWfkWgAI0wWs/ItAAAGDgYtAgAyN+QWaAAihwMWm4G8QQRDiMcCBcH3Cc+CDv/7xA4Tvh9Rz/y8QADBwMWgQAZG/ILNAARQ4GLTcDeIIIhxGOBAuD7hOfBB3/94gcJ3w+o5/5eIAIAAAVwWgQAVQ2ORaIQwEMAJiDg95G4nQL7mQVWI6GwRcfsZAcsKkJvxgxEjzFUgfHoSQ9Qq7KNwqHwuB13MA4a1q/DmBrHgPcmjiGoh//EwC5nGPEmS4RcfkVKOhJf+WOgoxJclFz3kgn//dBA+ya1GhurNn8zb//9NNutNuhz31f////9vt///z+IdAEAAAK4LQIAKobHItEIYCGAExBwe8jcToF9zIKrEdDYIuP2MgOWFSE34wYiR5iqQPj0JIeoVdlG4VD4XA67mAcNa1fhzA1jwHuTRxDUQ//iYBczjHiTJcIuPyKlHQkv/LHQUYkuSi57yQT//uggfZNajQ3Vmz+Zt//+mm3Wm3Q576v////+32///5/EOgAAADVghQAAAAA//uQZAUAB1WI0PZugAAAAAoQwAAAEk3nRd2qAAAAACiDgAAAAAAABCqEEQRLCgwpBGMlJkIz8jKhGvj4k6jzRnqasNKIeoh5gI7BJaC1A1AoNBjJgbyApVS4IDlZgDU5WUAxEKDNmmALHzZp0Fkz1FMTmGFl1FMEyodIavcCAUHDWrKAIA4aa2oCgILEBupZgHvAhEBcZ6joQBxS76AgccrFlczBvKLC0QI2cBoCFvfTDAo7eoOQInqDPBtvrDEZBNYN5xwNwxQRfw8ZQ5wQVLvO8OYU+mHvFLlDh05Mdg7BT6YrRPpCBznMB2r//xKJjyyOh+cImr2/4doscwD6neZjuZR4AgAABYAAAABy1xcdQtxYBYYZdifkUDgzzXaXn98Z0oi9ILU5mBjFANmRwlVJ3/6jYDAmxaiDG3/6xjQQCCKkRb/6kg/wW+kSJ5//rLobkLSiKmqP/0ikJuDaSaSf/6JiLYLEYnW/+kXg1WRVJL/9EmQ1YZIsv/6Qzwy5qk7/+tEU0nkls3/zIUMPKNX/6yZLf+kFgAfgGyLFAUwY//uQZAUABcd5UiNPVXAAAApAAAAAE0VZQKw9ISAAACgAAAAAVQIygIElVrFkBS+Jhi+EAuu+lKAkYUEIsmEAEoMeDmCETMvfSHTGkF5RWH7kz/ESHWPAq/kcCRhqBtMdokPdM7vil7RG98A2sc7zO6ZvTdM7pmOUAZTnJW+NXxqmd41dqJ6mLTXxrPpnV8avaIf5SvL7pndPvPpndJR9Kuu8fePvuiuhorgWjp7Mf/PRjxcFCPDkW31srioCExivv9lcwKEaHsf/7ow2Fl1T/9RkXgEhYElAoCLFtMArxwivDJJ+bR1HTKJdlEoTELCIqgEwVGSQ+hIm0NbK8WXcTEI0UPoa2NbG4y2K00JEWbZavJXkYaqo9CRHS55FcZTjKEk3NKoCYUnSQ0rWxrZbFKbKIhOKPZe1cJKzZSaQrIyULHDZmV5K4xySsDRKWOruanGtjLJXFEmwaIbDLX0hIPBUQPVFVkQkDoUNfSoDgQGKPekoxeGzA4DUvnn4bxzcZrtJyipKfPNy5w+9lnXwgqsiyHNeSVpemw4bWb9psYeq//uQZBoABQt4yMVxYAIAAAkQoAAAHvYpL5m6AAgAACXDAAAAD59jblTirQe9upFsmZbpMudy7Lz1X1DYsxOOSWpfPqNX2WqktK0DMvuGwlbNj44TleLPQ+Gsfb+GOWOKJoIrWb3cIMeeON6lz2umTqMXV8Mj30yWPpjoSa9ujK8SyeJP5y5mOW1D6hvLepeveEAEDo0mgCRClOEgANv3B9a6fikgUSu/DmAMATrGx7nng5p5iimPNZsfQLYB2sDLIkzRKZOHGAaUyDcpFBSLG9MCQALgAIgQs2YunOszLSAyQYPVC2YdGGeHD2dTdJk1pAHGAWDjnkcLKFymS3RQZTInzySoBwMG0QueC3gMsCEYxUqlrcxK6k1LQQcsmyYeQPdC2YfuGPASCBkcVMQQqpVJshui1tkXQJQV0OXGAZMXSOEEBRirXbVRQW7ugq7IM7rPWSZyDlM3IuNEkxzCOJ0ny2ThNkyRai1b6ev//3dzNGzNb//4uAvHT5sURcZCFcuKLhOFs8mLAAEAt4UWAAIABAAAAAB4qbHo0tIjVkUU//uQZAwABfSFz3ZqQAAAAAngwAAAE1HjMp2qAAAAACZDgAAAD5UkTE1UgZEUExqYynN1qZvqIOREEFmBcJQkwdxiFtw0qEOkGYfRDifBui9MQg4QAHAqWtAWHoCxu1Yf4VfWLPIM2mHDFsbQEVGwyqQoQcwnfHeIkNt9YnkiaS1oizycqJrx4KOQjahZxWbcZgztj2c49nKmkId44S71j0c8eV9yDK6uPRzx5X18eDvjvQ6yKo9ZSS6l//8elePK/Lf//IInrOF/FvDoADYAGBMGb7FtErm5MXMlmPAJQVgWta7Zx2go+8xJ0UiCb8LHHdftWyLJE0QIAIsI+UbXu67dZMjmgDGCGl1H+vpF4NSDckSIkk7Vd+sxEhBQMRU8j/12UIRhzSaUdQ+rQU5kGeFxm+hb1oh6pWWmv3uvmReDl0UnvtapVaIzo1jZbf/pD6ElLqSX+rUmOQNpJFa/r+sa4e/pBlAABoAAAAA3CUgShLdGIxsY7AUABPRrgCABdDuQ5GC7DqPQCgbbJUAoRSUj+NIEig0YfyWUho1VBBBA//uQZB4ABZx5zfMakeAAAAmwAAAAF5F3P0w9GtAAACfAAAAAwLhMDmAYWMgVEG1U0FIGCBgXBXAtfMH10000EEEEEECUBYln03TTTdNBDZopopYvrTTdNa325mImNg3TTPV9q3pmY0xoO6bv3r00y+IDGid/9aaaZTGMuj9mpu9Mpio1dXrr5HERTZSmqU36A3CumzN/9Robv/Xx4v9ijkSRSNLQhAWumap82WRSBUqXStV/YcS+XVLnSS+WLDroqArFkMEsAS+eWmrUzrO0oEmE40RlMZ5+ODIkAyKAGUwZ3mVKmcamcJnMW26MRPgUw6j+LkhyHGVGYjSUUKNpuJUQoOIAyDvEyG8S5yfK6dhZc0Tx1KI/gviKL6qvvFs1+bWtaz58uUNnryq6kt5RzOCkPWlVqVX2a/EEBUdU1KrXLf40GoiiFXK///qpoiDXrOgqDR38JB0bw7SoL+ZB9o1RCkQjQ2CBYZKd/+VJxZRRZlqSkKiws0WFxUyCwsKiMy7hUVFhIaCrNQsKkTIsLivwKKigsj8XYlwt/WKi2N4d//uQRCSAAjURNIHpMZBGYiaQPSYyAAABLAAAAAAAACWAAAAApUF/Mg+0aohSIRobBAsMlO//Kk4soosy1JSFRYWaLC4qZBYWFRGZdwqKiwkNBVmoWFSJkWFxX4FFRQWR+LsS4W/rFRb/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////VEFHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAU291bmRib3kuZGUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMjAwNGh0dHA6Ly93d3cuc291bmRib3kuZGUAAAAAAAAAACU=");

  beepInfo.play();
  beepInfo.pause();
  beepInfo.currentTime = 0;

  beepError.play();
  beepError.pause();
  beepError.currentTime = 0;

  beepOk.play();
  beepOk.pause();
  beepOk.currentTime = 0;

  document.body.removeEventListener('click', unlockAudio)
  document.body.removeEventListener('touchstart', unlockAudio)
}


@Component({components: {}})
export default class ScanView extends Vue {

  getScanModeName(mode: ScanMode) {
    return mode === ScanMode.ENTER ? 'ВХОД'
        : mode === ScanMode.EXIT ? 'ВЫХОД'
            : 'ИНФО'
  }

  getTime(timestamp: number) {
    return (new Intl.DateTimeFormat('ru-RU', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false // 24-часовой формат
    })).format(timestamp)
  }

  enableAudio() {

    beepInfo = new Audio('data:audio/ogg;base64,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')
    beepError = new Audio("error.wav")
    beepOk = new Audio("data:audio/wav;base64,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");

  }

  beepOk() {
    beepOk?.play()
  }

  beepError() {
    beepError?.play()
  }

  beepInfo() {
    beepInfo?.play()
  }

  renderStyle = {}

  eventData: {
    name: string,
    date?: number,
    dbId?: number
  } | null = null

  eventId = ''

  userData: User | null = null
  access: boolean | null = false
  isComma = false // разделитель для csv

  scanMode: ScanMode = ScanMode.ENTER

  prevFrameScanValue = ''
  scanValue = ''
  inputValue = ''
  lastScanAt = 0

  pending = false

  scanResult?: ScanResult

  filePath?: Blob = undefined
  drop = false
  addScan = false

  html5QrcodeScanner?: Html5QrcodeScanner

  getColor() {
    return this.scanValue && !this.pending && this.scanMode != ScanMode.INFO ? (
        !this.scanResult?.committed ? 'bg-red-lighten-4'
            : this.scanResult.committed ? 'bg-green-lighten-4'
                : 'bg-orange-lighten-4'
    ) : ''
  }

  // async onInput() {
  //
  //   this.ticket = undefined
  //   this.prevFrameScanValue = this.scanValue
  //
  //   this.updateTicket()
  // }

  clearInputValue() {
    this.scanValue = ''
    this.inputValue = ''
    this.prevFrameScanValue = ''
    this.scanResult = undefined
  }

  async onInput(value: string) {

    value = value.trim()

    if (!value) {
      this.clearInputValue()

    } else {
      this.scanValue = value
      this.updateTicket()
    }


  }

  // Изменение поля ввода тоже это вызывает
  async onScan(value: string) {

    if (!value) {
      this.clearInputValue()

    } else
        //if (value != this.prevFrameScanValue || (this.lastScanAt + 1000 * 5) < Date.now())
    if (value != this.prevFrameScanValue) {
      this.scanValue = value
      this.inputValue = this.scanValue
      this.prevFrameScanValue = this.scanValue
      this.lastScanAt = Date.now()

      this.updateTicket()
    }


  }

  fileReadResult: any | null = null // результат чтения файла тут

  async requestAccess() {
    set(getRef(`events/${this.eventId}/users/${this.userData?.uid}/`), {access: false, email: this.userData?.email})
  }

  async fileSelect() {

    if (!this.filePath) return;

    console.log(this.filePath[0])

    //Получаем выбранный файл
    var file = this.filePath[0] as Blob

    // Создаем объект FileReader
    var reader = new FileReader();

    const eventId = this.eventId

    // Обработчик события, вызываемого при успешном чтении файла
    reader.onload = async (event) => {
      // Получаем содержимое файла
      this.fileReadResult = event.target?.result;
    };

    // Читаем файл как текст
    reader.readAsText(file);

  }

  accessUsers: EventUsers | null = null

  setUserAccess(key, access) {

    set(getRef('events/' + this.eventId + '/users/' + key + '/access'), !access)

    //console.log(key, access)

  }

  toggleAccessAll(toggle) {

    for (const key in this.accessUsers)
      this.accessUsers[key].access = toggle

    set(getRef('events/' + this.eventId + '/users'), this.accessUsers)

  }

  safe = ''

  async deleteALLScans() {
    await deleteALLScans(this.eventId);
    this.safe = ''
  }

  async processFile() {
    if (!this.fileReadResult) return;


    // Разделяем содержимое файла на строки
    var lines = ('' + this.fileReadResult).split('\n');

    const rootData = {}

    console.log('Всего строк в файле', lines.length)

    // Построчно обрабатываем файл
    lines.forEach((line) => {

      const cells = line.split(this.isComma ? ',' : ';')

      const code = cells[this.ticketCodePosition - 1]
      if (!code || !code.trim()) {
        console.error('no code')
        return;
      }

      //console.log('code', code)

      const data: DBTicket = {
        desc: '' + cells[this.ticketLabelPosition - 1] //line.replace(code, '')
      }
      rootData[code] = data

    })

    if (this.drop)
        // set(getRef(`tickets/${eventId}/${code}`),data)
      await set(getRef(`tickets/${this.eventId}/`), rootData)
    else {

      const currentData = (await get(getRef(`tickets/${this.eventId}/`))).val()

      await set(getRef(`tickets/${this.eventId}/`), {
        ...currentData,
        ...rootData
      })

    }

  }

  isStringWrongKey(string: string) {
    return string.includes('[')
        || string.includes(']')
        || string.includes('.')
        || string.includes('#')
        || string.includes('$')
  }

  async addToDatabase(ticketId) {

    if (!ticketId) return;

    await set(getRef(`tickets/${this.eventId}/${ticketId}/`), {
      desc: 'Служебный билет'
    })

  }


  accessDialog = false

  ticketCodePosition = 1
  ticketLabelPosition = 2

  isAdmin() {
    //return !!this.$route.query['admin']
    return this._isAdmin
  }

  downloadCSVPasses() {

    //console.log(Array.from(this.scans).map(v=>v.entrance))

    function download(data, filename, type) {
      var file = new Blob([data], {type: type});
      // if (window.navigator.msSaveOrOpenBlob) // IE10+
      //   window.navigator.msSaveOrOpenBlob(file, filename);
      // else { // Others
      var a = document.createElement("a"),
          url = URL.createObjectURL(file);
      a.href = url;
      a.download = filename + '.' + type;
      document.body.appendChild(a);
      a.click();
      setTimeout(function () {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
      //}
    }

    // let csvText = '';
    //
    // for (const key in this.scans)
    //   csvText += key + ';' + (new Date(this.scans[key].timestamp)).toLocaleString() + ';' + '\n'
    //
    // download(csvText, 'Проходы', 'csv')

  }

  getStat() {

    if (!this.tickets || !this.scans) return {}

    let csv = ''
    for (const keyT in this.tickets)
      csv = csv + keyT + ';' + (this.tickets[keyT].desc ?? '').replace('место', 'место;') + ';' + !!this.scans[keyT] + '\n'

    console.log(csv)


  }

  getStat2() {

    if (!this.tickets || !this.scans) return {}

    let stats = {}

    for (const keyT in this.tickets) {
      const ticket = this.tickets[keyT]
      if (!ticket) continue;

      const sector = ticket.desc ? ticket.desc.split(',')[0] : ''

      if (!stats[sector])
        stats[sector] = {
          enter: 0,
          notEnter: 0,
          enterList: [],
          notEnterList: []
        }

      if (this.scans[keyT]) {
        stats[sector].enter += 1
        stats[sector].enterList.push(ticket.desc)
      } else {
        stats[sector].notEnterList.push(ticket.desc)
        stats[sector].notEnter += 1

      }

    }

    const sortedEntries = Object.entries(stats).sort(([keyA], [keyB]) => keyA.localeCompare(keyB));
    stats = Object.fromEntries(sortedEntries);

    let text = ''
    for (const k in stats) {
      text = text + k + ';' + stats[k].notEnter + ';' + (stats[k].enter + stats[k].notEnter) + '\n'
    }
    console.log(text)

  }

  // Вызывается когда камера распознала новое значение
  async updateTicket() {

    this.scanResult = undefined

    if (this.isStringWrongKey(this.scanValue))
      return this.beepError();


    if (this.isAdmin() && this.addScan) {
      await this.addToDatabase(this.scanValue)
      this.inputValue = this.inputValue + ' Добавлен'
      return;
    }

    // this.ticket = await getTicket(this.eventId, this.scanValue)
    //
    // if (!this.ticket) {
    //   this.beepError()
    //   return;
    // }


    //if (this.scanMode === ScanMode.ENTER) {

    this.pending = true

    this.scanResult = await scan(this.eventId, this.scanValue, this.scanMode)

    console.log('scanResult', this.scanResult)

    if (this.scanResult?.committed || this.scanMode === ScanMode.INFO)
      this.beepOk()
    else
      this.beepError()

    this.pending = false

    return;
    //}

    // if (!this.ticket.inside) {
    //
    //   await scanEnter2(this.eventId, this.scanValue, ScanMode.ENTER)
    //   this.ticket = await getTicket(this.eventId, this.scanValue)
    //
    //   beepOk.play()
    //
    // } else {
    //   beepError.play()
    //   return;
    //
    // }

    //
    // } else if (this.scanMode === ScanMode.EXIT && this.ticket?.inside) {
    //   if (!this.ticket.inside) {
    //
    //     await scanEnter(this.eventId, this.scanValue, ScanMode.EXIT)
    //     this.ticket = await getTicket(this.eventId, this.scanValue)
    //
    //     this.beepOk()
    //
    //   } else {
    //     this.beepError()
    //     return;
    //
    //   }
    //
    //
    // } else {
    //   this.beepInfo()
    // }

  }

  tickets?: DBTickets = undefined
  scans?: DBScans = undefined

  _isAdmin = false

  async mounted() {

    this.userData = await getCurrentUser()
    this._isAdmin = !!(await get(getRef(`admins/${this.userData?.uid ?? 0}/`))).val()

    document.body.addEventListener('click', unlockAudio);
    document.body.addEventListener('touchstart', unlockAudio);

    // setInterval(() => {
    //   this.renderStyle = {
    //     maxHeight: '60%',
    //     border: 'none',
    //     'font-size': 'small'
    //   }
    // }, 3000)

    this.renderStyle = {
      maxHeight: '50%',
      border: 'none',
      'font-size': 'small',
      overflow: 'hidden',
    }

    this.eventId = '' + this.$route.params.eventId

    if (!this.eventId)
      this.$router.resolve('/')


    if (this.isAdmin()) {

      onValue(getRef(`events/${this.eventId}/users`), snapshot => {
        this.accessUsers = snapshot.val() as EventUsers
      })

    }

    if (this.isAdmin())
      this.access = true
    else
      onValue(getRef(`events/${this.eventId}/users/${this.userData?.uid}/access`), snapshot => {
        this.access = snapshot.val()
      })

    onValue(getRef(`tickets/${this.eventId}`), snapshot => {
      if (snapshot.exists())
        this.tickets = snapshot.val()
    })

    onValue(getRef(`scans/${this.eventId}`), snapshot => {
      if (snapshot.exists())
        this.scans
      this.scans = snapshot.val()
    })

    let qrboxFunction = function (viewfinderWidth, viewfinderHeight) {
      let minEdgePercentage = 0.7; // 70%
      let minEdgeSize = Math.min(viewfinderWidth, viewfinderHeight);
      let qrboxSize = Math.floor(minEdgeSize * minEdgePercentage);
      return {
        width: qrboxSize,
        height: qrboxSize
      };
    }

    this.html5QrcodeScanner = new Html5QrcodeScanner(
        "reader",
        {
          aspectRatio: 1.777778,
          fps: 6,
          // qrbox: {width: 240, height: 240},
          qrbox: qrboxFunction,
          rememberLastUsedCamera: true,
          showTorchButtonIfSupported: false,
          // Only support camera scan type.
          supportedScanTypes: [
            Html5QrcodeScanType.SCAN_TYPE_CAMERA,
            //Html5QrcodeScanType.SCAN_TYPE_FILE,
          ],
          formatsToSupport: [
            Html5QrcodeSupportedFormats.QR_CODE,
            Html5QrcodeSupportedFormats.CODE_128,
            Html5QrcodeSupportedFormats.CODE_39,
            Html5QrcodeSupportedFormats.EAN_8,
            Html5QrcodeSupportedFormats.EAN_13,
            Html5QrcodeSupportedFormats.ITF,
          ]
        },
        false
        //formatsToSupport: formatsToSupport
    );

    this.html5QrcodeScanner.render(this.onScan.bind(this), undefined);

    let videoElLoaded = false
    setInterval(() => {
      if (videoElLoaded) return;
      const videoEl = document.querySelector('video')
      if (videoEl) {

        videoEl.style.cssText = '' +
            // 'height: auto !important; ' +
            // 'width: auto !important; ' +
            'max-height: 300px !important; ' +
            'max-width: 100% !important; ' +
            // 'object-fit: cover !important;' +
            'display: block;' +
            '';
        videoElLoaded = true
      }
    }, 1000)

    // getState() = 1 нет доступа к камере

  }


}

